var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 16",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "View") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n      .ViewBkg{fill:#fff;}\r\n      .View{fill:#1352de;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "ViewBkg",
    d: "M.0182-.0182h12V15.9818H.0182V-.0182Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "View",
    d: "M-.0327-.0182V15.9818h7.6667c2.3932,0,4.3333-1.9401,4.3333-4.3333V-.0182H-.0327ZM11.3007,11.6485c0,2.025-1.6416,3.6667-3.6667,3.6667H.634V.6485h10.6667v11ZM3.3007,4.6485h5.3333v.6667H3.3007v-.6667ZM3.3007,7.3152h5.3333v.6667H3.3007v-.6667ZM3.3007,9.9818h4v.6667h-4v-.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewFile);
export default __webpack_public_path__ + "static/media/ViewFile.ed54c09440f02a49aff23c3c2fe8d5fc.svg";
export { ForwardRef as ReactComponent };